// As with any other front end config file, don't put secrets in here

export default {
	authServer: 'https://aks-feature.sorted.com/auth',
	apiHost: 'https://api-int.sorted.com/pro-ui',
	gaPropertyId: 'UA-174047108-2',
	remotes: {
		shipments: 'http://localhost:3101',
		sortedReact: 'http://localhost:3200/remoteEntry.js'
	}
};
